import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "formBody nsubForm-emailSection" };
const _hoisted_2 = {
    key: 1,
    class: "nsubForm-welcomeText"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    key: 2,
    class: "nsubForm-progress",
    "aria-hidden": "true"
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 0,
    class: "this-line"
};
const _hoisted_7 = ["data-step"];
const _hoisted_8 = ["data-step"];
const _hoisted_9 = ["data-step"];
const _hoisted_10 = { class: "nsubForm-topics" };
const _hoisted_11 = ["data-step"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = ["data-step"];
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = { key: 8 };
import { computed, onMounted, ref, watch } from 'vue';
import { ThemeButton, ThemeFormField, ThemeIcon, ThemeLoader, ThemeFormRow } from '../../../front/components';
import { restRequestTheme } from '../../../front/lib/rest-api';
import { dispatchGtmEvent } from '../../../front/gtm';
var Step;
(function (Step) {
    Step["Welcome"] = "welcome";
    Step["Occupation"] = "myOccupaction";
    Step["Topics"] = "myInterests";
    Step["Success"] = "success";
    Step["Failure"] = "failure";
})(Step || (Step = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubscriptionForm',
    props: {
        newsletter: {},
        subscriptionData: {}
    },
    emits: ['dismiss'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const enums = props.newsletter.enums;
        const emit = __emit;
        const step = ref(Step.Welcome);
        const email = ref(props.subscriptionData.email);
        const modifiedEmail = ref(false);
        const sub = ref(props.subscriptionData);
        const loading = ref(false);
        const testing = ref(false);
        const emailEl = ref();
        const municipalityOptions = enums.regions.flatMap((reg) => reg.municipalities.map((mun) => ({
            label: `${mun} (${reg.name})`,
            key: mun,
        }))).sort((a, b) => a.label.localeCompare(b.label, 'sv'));
        watch(() => sub.value.municipality, (after, before) => {
            var _a;
            if (after !== before) {
                sub.value.region = ((_a = enums.regions.find((reg) => reg.municipalities.includes(after))) === null || _a === void 0 ? void 0 : _a.name) || '';
            }
        });
        const hasChanges = computed(() => {
            if (!sub.value) {
                return false;
            }
            return JSON.stringify(sub.value) !== JSON.stringify(sub.value);
        });
        const progress = computed(() => {
            if (step.value === Step.Welcome) {
                return 1;
            }
            else if (step.value === Step.Occupation) {
                return 2;
            }
            else if (step.value === Step.Topics || step.value === Step.Success || step.value === Step.Failure) {
                return 3;
            }
            return 0;
        });
        const eduTopicsEnabled = computed(() => {
            const matchesRule = (rule) => {
                return sub.value.occupationCategory === rule.occupation_category ||
                    sub.value.occupationForm === rule.occupation_form;
            };
            // To show topics selection, at least one rule must match 'show' and no rule must match 'hide'
            return !enums.educationTopicsRules.filter((rule) => rule.rule === 'hide').some(matchesRule) &&
                enums.educationTopicsRules.filter((rule) => rule.rule === 'show').some(matchesRule);
        });
        const primaryAction = computed(() => {
            return {
                title: (function () {
                    switch (step.value) {
                        case Step.Occupation:
                            return eduTopicsEnabled.value ? 'Gå vidare' : 'Spara din prenumeration';
                        case Step.Topics:
                            return 'Spara din prenumeration';
                        case Step.Success:
                            return 'Stäng';
                        case Step.Failure:
                            return 'Försök igen';
                        default:
                            return 'Gå vidare';
                    }
                }()),
                disabled: (function () {
                    switch (step.value) {
                        case Step.Welcome:
                            return !sub.value.lists.length;
                        case Step.Occupation:
                            return !(sub.value.municipality && sub.value.occupationForm && sub.value.occupationCategory) || !(enums.occupationForms.includes(sub.value.occupationForm) &&
                                enums.occupationCategories.includes(sub.value.occupationCategory) &&
                                municipalityOptions.some((mun) => mun.key === sub.value.municipality));
                        case Step.Topics:
                            return !sub.value.educationalSubjects.length;
                        default:
                            return false;
                    }
                }()),
                iconAfter: (function () {
                    if ((step.value === Step.Occupation && !eduTopicsEnabled.value) || step.value === Step.Topics || step.value === Step.Success) {
                        return null;
                    }
                    else if (step.value === Step.Failure) {
                        return 'reload';
                    }
                    return 'chevron-right';
                }()),
                async handler() {
                    if (this.disabled) {
                        return;
                    }
                    if (step.value === Step.Welcome) {
                        step.value = Step.Occupation;
                    }
                    else if (step.value === Step.Occupation) {
                        if (eduTopicsEnabled.value) {
                            step.value = Step.Topics;
                        }
                        else {
                            step.value = await saveSubscription();
                        }
                    }
                    else if (step.value === Step.Topics) {
                        step.value = await saveSubscription();
                    }
                    else if (step.value === Step.Success) {
                        emit('dismiss');
                    }
                    else if (step.value === Step.Failure) {
                        step.value = Step.Welcome;
                    }
                },
            };
        });
        const secondaryAction = computed(() => {
            switch (step.value) {
                case Step.Failure:
                case Step.Success:
                case Step.Welcome:
                    return null;
                default:
                    return {
                        title: 'Tillbaka',
                        disabled: loading.value,
                        icon: 'chevron-left',
                        handler() {
                            if (this.disabled) {
                                return;
                            }
                            switch (step.value) {
                                case Step.Occupation:
                                    step.value = Step.Welcome;
                                    break;
                                case Step.Topics:
                                    step.value = Step.Occupation;
                                    break;
                                case Step.Success:
                                    emit('dismiss');
                                    break;
                            }
                        },
                    };
            }
        });
        onMounted(() => {
            getUserByEmail();
        });
        function beginModifyEmail() {
            modifiedEmail.value = email.value;
            setTimeout(() => {
                var _a;
                (_a = emailEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
        function discardModifiedEmail() {
            email.value = modifiedEmail.value || '';
            modifiedEmail.value = false;
        }
        async function applyModifiedEmail() {
            // TODO Reload data and start again
            modifiedEmail.value = false;
            await getUserByEmail();
            step.value = Step.Welcome;
        }
        function onListChange(list, checked) {
            if (!sub.value) {
                return;
            }
            if (checked) {
                sub.value.lists.push(list.id);
            }
            else {
                sub.value.lists = sub.value.lists.filter(id => id !== list.id);
            }
        }
        function onTopicChange(selected, allSubjects) {
            if (!sub.value) {
                return;
            }
            sub.value.educationalSubjects = sub.value.educationalSubjects.filter(topic => !allSubjects.includes(topic) || selected.includes(topic));
            for (const subject of allSubjects) {
                if (sub.value.educationalSubjects.includes(subject)) {
                    if (!selected.includes(subject)) {
                        sub.value.educationalSubjects = sub.value.educationalSubjects.filter(topic => topic !== subject);
                    }
                }
                else if (selected.includes(subject)) {
                    sub.value.educationalSubjects.push(subject);
                }
            }
        }
        async function getUserByEmail() {
            if (!email.value || loading.value) {
                return;
            }
            loading.value = true;
            const subscriber = await restRequestTheme('GET', `editnews/newsletter/optin?email=${encodeURIComponent(email.value)}`).then(resp => resp.payload);
            if ((subscriber === null || subscriber === void 0 ? void 0 : subscriber.email) === email.value) {
                sub.value = subscriber;
            }
            loading.value = false;
        }
        async function saveSubscription() {
            loading.value = true;
            let subId = sub.value.id;
            let respStep = Step.Failure;
            try {
                if (!subId) {
                    const resp = await restRequestTheme('PUT', 'editnews/newsletter/optin', {
                        init: {
                            body: JSON.stringify({ email: email.value }),
                        }
                    });
                    if (resp.payload.id) {
                        subId = resp.payload.id;
                        if (subId) {
                            dispatchGtmEvent('SKP.NewsletterForm.subscription.created', {
                                email: email.value,
                                subscriptionId: subId,
                            });
                        }
                    }
                }
                if (subId) {
                    const resp = await restRequestTheme('POST', `editnews/newsletter/optin/${subId}`, {
                        init: {
                            body: JSON.stringify(sub.value),
                        }
                    });
                    if (resp.payload.id) {
                        respStep = Step.Success;
                        dispatchGtmEvent('SKP.NewsletterForm.subscription.modified', {
                            email: email.value,
                            subscriptionId: subId,
                        });
                    }
                }
                else {
                    respStep = Step.Failure;
                    dispatchGtmEvent('SKP.NewsletterForm.subscription.notFound', {
                        email: email.value,
                    });
                }
            }
            catch (err) {
                showError(err);
            }
            loading.value = false;
            return respStep;
        }
        function showError(err) {
            console.error(err);
            alert('Ett fel uppstod. Försök igen senare.');
        }
        function mapStrToOption(str) {
            return {
                label: str,
                key: str,
            };
        }
        function filterTopicSubjects(topic) {
            return sub.value.educationalSubjects.includes(topic);
        }
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["nsubForm", { [`step--${step.value}`]: true }])
            }, [
                _cache[14] || (_cache[14] = _createElementVNode("header", null, [
                    _createElementVNode("h3", { class: "this-subtitle" }, "Prenumerera på Skolportens olika nyhetsbrev")
                ], -1)),
                (sub.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["nsubForm-body", { 'is--modifyingEmail': modifiedEmail.value }])
                    }, [
                        (loading.value)
                            ? (_openBlock(), _createBlock(_unref(ThemeLoader), {
                                key: 0,
                                class: "nsubForm-loader"
                            }))
                            : _createCommentVNode("", true),
                        _createElementVNode("section", _hoisted_1, [
                            _createVNode(_unref(ThemeFormField), {
                                ref_key: "emailEl",
                                ref: emailEl,
                                type: "email",
                                label: "E-Post",
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                disabled: !modifiedEmail.value
                            }, null, 8, ["modelValue", "disabled"]),
                            (!modifiedEmail.value)
                                ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                    key: 0,
                                    title: "Byt e-postadress",
                                    icon: "pencil",
                                    fill: "none",
                                    color: "neutral",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (beginModifyEmail()))
                                }))
                                : _createCommentVNode("", true),
                            (modifiedEmail.value && email.value === modifiedEmail.value)
                                ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                    key: 1,
                                    title: "Avbryt",
                                    icon: "times-round-outline",
                                    fill: "none",
                                    color: "neutral",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (discardModifiedEmail()))
                                }))
                                : _createCommentVNode("", true),
                            (modifiedEmail.value && email.value !== modifiedEmail.value)
                                ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                    key: 2,
                                    title: "Byta",
                                    icon: "arrow-right-long",
                                    fill: "solid",
                                    color: "success",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (applyModifiedEmail()))
                                }))
                                : _createCommentVNode("", true)
                        ]),
                        (step.value === Step.Welcome)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                                _createElementVNode("div", {
                                    class: "richContent",
                                    innerHTML: sub.value.id ? (_a = _ctx.newsletter.json.form_strings) === null || _a === void 0 ? void 0 : _a.welcome_existing : (_b = _ctx.newsletter.json.form_strings) === null || _b === void 0 ? void 0 : _b.welcome_new
                                }, null, 8, _hoisted_3)
                            ]))
                            : _createCommentVNode("", true),
                        (step.value !== Step.Failure)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (num) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: num }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["this-marker", {
                                                    'is--active': progress.value === num,
                                                    'is--completed': progress.value > num,
                                                }])
                                        }, [
                                            (progress.value <= num)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(num), 1))
                                                : _createCommentVNode("", true),
                                            (progress.value > num)
                                                ? (_openBlock(), _createBlock(_unref(ThemeIcon), {
                                                    key: 1,
                                                    name: "check"
                                                }))
                                                : _createCommentVNode("", true)
                                        ], 2),
                                        (num < 3)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 64))
                            ]))
                            : _createCommentVNode("", true),
                        (step.value === Step.Welcome)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 3,
                                class: "formBody",
                                "data-step": Step.Welcome
                            }, [
                                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "nsubForm-sectionTitle" }, "Välj vilka nyhetsbrev som du vill prenumerera på", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enums).lists, (list) => {
                                    return (_openBlock(), _createBlock(_unref(ThemeFormField), {
                                        type: "checkbox",
                                        key: list.id,
                                        name: list.id,
                                        "aria-label": list.label,
                                        description: `<b>${list.label}</b><br>${list.description}`,
                                        checked: sub.value.lists.includes(list.id),
                                        onChange: ($event) => (onListChange(list, $event.target.checked))
                                    }, null, 8, ["name", "aria-label", "description", "checked", "onChange"]));
                                }), 128))
                            ], 8, _hoisted_7))
                            : _createCommentVNode("", true),
                        (step.value === Step.Occupation)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 4,
                                class: "formBody",
                                "data-step": Step.Occupation
                            }, [
                                _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "nsubForm-sectionTitle" }, "Jag arbetar inom", -1)),
                                _createVNode(_unref(ThemeFormRow), { columns: 2 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ThemeFormField), {
                                            type: "select",
                                            modelValue: sub.value.municipality,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((sub.value.municipality) = $event)),
                                            label: "Arbetar i (Kommun):",
                                            options: _unref(municipalityOptions),
                                            placeholder: "Välj vilken kommun du arbetar i",
                                            required: ""
                                        }, null, 8, ["modelValue", "options"]),
                                        _createVNode(_unref(ThemeFormField), {
                                            type: "select",
                                            modelValue: sub.value.occupationForm,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((sub.value.occupationForm) = $event)),
                                            label: "Arbetsplats:",
                                            options: _unref(enums).occupationForms.map(mapStrToOption),
                                            placeholder: "Välj din primära arbetsplats",
                                            required: ""
                                        }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(ThemeFormRow), { columns: 1 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ThemeFormField), {
                                            type: "select",
                                            modelValue: sub.value.occupationCategory,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((sub.value.occupationCategory) = $event)),
                                            label: "Arbetar som:",
                                            options: _unref(enums).occupationCategories.map(mapStrToOption),
                                            placeholder: "Välj din yrkeskategori",
                                            required: ""
                                        }, null, 8, ["modelValue", "options"])
                                    ]),
                                    _: 1
                                })
                            ], 8, _hoisted_8))
                            : _createCommentVNode("", true),
                        (step.value === Step.Topics)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 5,
                                class: "formBody",
                                "data-step": Step.Topics
                            }, [
                                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "nsubForm-sectionTitle" }, "Jag undervisar i följande ämnen/ämnesområden", -1)),
                                _createElementVNode("div", _hoisted_10, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enums).educationTopics, (topic) => {
                                        return (_openBlock(), _createBlock(_unref(ThemeFormField), {
                                            type: "choice-multiple",
                                            key: topic.title,
                                            label: topic.title,
                                            choices: topic.subjects,
                                            "model-value": topic.subjects.filter(filterTopicSubjects),
                                            "onUpdate:modelValue": ($event) => (onTopicChange($event, topic.subjects))
                                        }, null, 8, ["label", "choices", "model-value", "onUpdate:modelValue"]));
                                    }), 128))
                                ])
                            ], 8, _hoisted_9))
                            : _createCommentVNode("", true),
                        (step.value === Step.Success)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 6,
                                class: "formBody",
                                "data-step": Step.Success
                            }, [
                                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "nsubForm-sectionTitle" }, "Tack för din prenumeration!", -1)),
                                _createElementVNode("div", {
                                    class: "richContent",
                                    innerHTML: (_d = (_c = _ctx.newsletter.json) === null || _c === void 0 ? void 0 : _c.form_strings) === null || _d === void 0 ? void 0 : _d.descr_success
                                }, null, 8, _hoisted_12)
                            ], 8, _hoisted_11))
                            : _createCommentVNode("", true),
                        (step.value === Step.Failure)
                            ? (_openBlock(), _createElementBlock("section", {
                                key: 7,
                                class: "formBody",
                                "data-step": Step.Failure
                            }, [
                                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "nsubForm-sectionTitle" }, "Oops... något gick fel!", -1)),
                                _createElementVNode("div", {
                                    class: "richContent",
                                    innerHTML: (_f = (_e = _ctx.newsletter.json) === null || _e === void 0 ? void 0 : _e.form_strings) === null || _f === void 0 ? void 0 : _f.descr_error
                                }, null, 8, _hoisted_14)
                            ], 8, _hoisted_13))
                            : _createCommentVNode("", true),
                        (testing.value)
                            ? (_openBlock(), _createElementBlock("pre", _hoisted_15, _toDisplayString(sub.value), 1))
                            : _createCommentVNode("", true)
                    ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", null, [
                    (secondaryAction.value)
                        ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                            key: 0,
                            class: "action--secondary",
                            title: secondaryAction.value.title,
                            icon: secondaryAction.value.icon,
                            size: "small",
                            variation: "chip",
                            fill: "outline",
                            color: "dark",
                            disabled: loading.value || secondaryAction.value.disabled,
                            onClick: _cache[7] || (_cache[7] = ($event) => (secondaryAction.value.handler()))
                        }, null, 8, ["title", "icon", "disabled"]))
                        : _createCommentVNode("", true),
                    (primaryAction.value)
                        ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                            key: 1,
                            class: "action--primary",
                            title: primaryAction.value.title,
                            "icon-after": primaryAction.value.iconAfter,
                            size: "small",
                            variation: "chip",
                            disabled: loading.value || primaryAction.value.disabled,
                            onClick: _cache[8] || (_cache[8] = ($event) => (primaryAction.value.handler()))
                        }, null, 8, ["title", "icon-after", "disabled"]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
